import { Page404 } from "@/components/404-page";
import { Toaster } from "@/components/ui/toaster";
import {
  customDomainHmoSubdomains,
  isAllowedOnCustomDomain,
} from "@/lib/constants/custom-domains";
import { createRootRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createRootRoute({
  beforeLoad: ({ location }) => {
    const subdomain = customDomainHmoSubdomains[window.location.hostname];
    if (subdomain && !isAllowedOnCustomDomain(location.pathname, subdomain)) {
      throw redirect({
        to: "/hmo/$subdomain",
        params: { subdomain },
        search: location.search,
        replace: true,
      });
    }
  },
  component: () => (
    <>
      <Outlet />
      <Toaster />
    </>
  ),
  notFoundComponent: Page404,
});
